import { render, staticRenderFns } from "./RiseupGoalInsight.vue?vue&type=template&id=8c167e14&scoped=true"
import script from "./RiseupGoalInsight.vue?vue&type=script&lang=js"
export * from "./RiseupGoalInsight.vue?vue&type=script&lang=js"
import style0 from "./RiseupGoalInsight.vue?vue&type=style&index=0&id=8c167e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c167e14",
  null
  
)

export default component.exports